import media from './tutorialMedia.json';

export const tutorials = [
  { id: 'primeros-pasos', destination: '/partidos' },
  { id: 'preparar-rival', destination: '/estadisticasEquipos' },
  { id: 'analizar-jugador', destination: '/rankingJugadores' },
  { id: 'consultar-acta', destination: '/partidos' },
  { id: 'exportar-informe', destination: '/partidos' },
].map(tutorial => ({ ...tutorial, media: media[tutorial.id] || null }));

const contextualTutorials = {
  '/dashboard': 'primeros-pasos',
  '/dashboard-clasico': 'primeros-pasos',
  '/clasificacion': 'primeros-pasos',
  '/clubes': 'preparar-rival',
  '/estadisticasEquipos': 'preparar-rival',
  '/rankingJugadores': 'analizar-jugador',
  '/jugador': 'analizar-jugador',
  '/estadisticas': 'analizar-jugador',
  '/partidos': 'consultar-acta',
  '/actaPartido': 'consultar-acta',
  '/informePartido': 'exportar-informe',
};

export const tutorialForPath = pathname => {
  const path = typeof pathname === 'string' ? pathname.replace(/\/+$/, '') : '';
  return Object.hasOwn(contextualTutorials, path) ? contextualTutorials[path] : undefined;
};
export const tutorialAsset = filename => `${process.env.PUBLIC_URL || ''}/tutorials/${filename}`;
